// extracted by mini-css-extract-plugin
export default {"buttonContainer":"TermsConditions_buttonContainer__-xUoJ","buttonText":"TermsConditions_buttonText__DMwpp","nextButton":"TermsConditions_nextButton__7ZKwO"};